var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenInvoicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 21,
    viewBox: "0 0 16.5 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Open_Invoices-Icon",
    d: "M19.5,14.25V11.625A3.375,3.375,0,0,0,16.125,8.25h-1.5A1.125,1.125,0,0,1,13.5,7.125v-1.5A3.375,3.375,0,0,0,10.125,2.25H8.25M8.25,15h7.5m-7.5,3H12M10.5,2.25H5.625A1.125,1.125,0,0,0,4.5,3.375v17.25A1.125,1.125,0,0,0,5.625,21.75h12.75A1.125,1.125,0,0,0,19.5,20.625V11.25a9,9,0,0,0-9-9Z",
    transform: "translate(-3.75 -1.5)",
    fill: "none",
    stroke: "#068453",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInvoicesIcon);
export default __webpack_public_path__ + "static/media/Open_Invoices-Icon.75327c2b7745dc7e69c8be3886e68d29.svg";
export { ForwardRef as ReactComponent };